const PATHS = [
  {
    path: '/material-browser',
    title: 'Material Browser',
    hide: false,
    disabled: true,
    useProjectName: false,
  },
  {
    path: '/app',
    title: 'Stackup Design',
    hide: false,
    useProjectName: true,
  },
  {
    path: '/about',
    title: 'About',
    hide: false,
    useProjectName: false,
  },
  {
    path: '/support',
    title: 'Support',
    hide: false,
    useProjectName: false,
  },
  {
    path: '/config',
    title: 'Config',
    hide: true,
    useProjectName: false,
  },
  {
    path: '/settings',
    title: 'Settings',
    hide: true,
    useProjectName: false,
  },
];

export function getTitle(pathname, projectName) {
  const rootPathName = 
    pathname
    .split('/')
    .filter(token => token !== '')[0];
  const currentPath = PATHS.find((path)=> path.path === `/${rootPathName}`);
  return currentPath ? 
    currentPath.useProjectName && projectName ? projectName :
    currentPath.title : '';
}

export default PATHS;



// WEBPACK FOOTER //
// ./src/lib/nav-paths.js